
import { Component, Prop, Vue, } from 'vue-property-decorator';
import { isLoginPromo, } from '~/apps/account/store/custom-content';
import type { LoginPromo, } from '~/apps/account/store/custom-content';
import FeedbackBox from '~/components/feedback-box/feedback-box.vue';
import { LoginContentTiles, } from '~/utils/models';

@Component({
	components: {
		FeedbackBox,
	},
})
export default class LoginContentTile extends Vue {
	collapse = true;

	handleExpandCollapse() {
		this.collapse = !this.collapse;
	}

	@Prop({
		type: Array,
		required: true,
	})
	loginContentTiles!: readonly LoginContentTiles[];

	@Prop({
		type: Object,
		required: false,
		validator(value) {
			return isLoginPromo(value);
		},
	})
	loginPromo?: LoginPromo;
}
